import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
export default [
  {
    prop: "Id",
    label: "No.",
    width: 80,
    align: "center",
    sortable: true
  },
  {
    prop: "Title",
    label: "Titulo",
    width: 300
  },
  {
    prop: "Description",
    label: "Descripción",
    width: 700
  },
  {
    prop: "StarDate",
    label: "Fecha", //label: "F. Inicio"
    sortKey: "StarDate",
    align: "center",
    formatter: DatetimeFormatter,
    width: 200,
    sortable: true
  },

  {
    prop: "EndDate",
    label: "F. Fin",
    sortKey: "EndDate",
    formatter: DatetimeFormatter,
    width: 200,
    sortable: true
  },

  {
    prop: "StartTime",
    label: "Hora de Inicio",
    sortKey: "StartTime",
    width: 200,
    sortable: true
  },
  {
    prop: "EndTime",
    label: "Hora de Cierre",
    sortKey: "EndTime",
    width: 200,
    sortable: true
  },
  {
    prop: "custPhoneN",
    label: "conacto del cliente ",
    sortKey: "EndTime",
    width: 200,
    sortable: true
  },
  {
    prop: "customerN",
    label: "nombre del cliente ",
    sortKey: "EndTime",
    width: 200,
    sortable: true
  },
  {
    prop: "fullname_ventas",
    label: "vendedor",
    sortKey: "VendorName",
    width: 200,
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "imgVendor"
    }
  },
  // {
  //   prop: "vendorsupport",
  //   label: "Soporte de  Venta",
  //   sortKey: "vendorsupport",
  //   width: 200,
  //   sortable: true,
  //   formatter: ImagePerson,
  //   attrs: {
  //     imgKey: ""
  //   }
  // },
  {
    prop: "ProspectName",
    label: "nombre del Prospecto ",

    width: 200,
    sortable: true,
    formatter: (props) => {
      // console.log("props", props);
      if (props.ClientCode == 0) {
        return "";
      } else {
        return props.ProspectName;
      }
    }
  },
  {
    prop: "ProspectPNumeber",
    label: "Contacto del Prospecto ",
    width: 200,
    sortable: true,
    formatter: (props) => {
      // console.log("props", props);
      if (props.ClientCode == 0) {
        return "";
      } else {
        return props.ProspectPNumeber;
      }
    }
  },
  {
    prop: "fullname_soporte",
    label: "Soporte de  Venta prospecto",
    sortKey: "vendorsupport",
    width: 230,
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: ""
    }
  }
];
